<template>
  <div class="card-icon" :class="`card-icon--${kind}`">
    <van-icon :name="iconName" size="20" color="#007AFF" />
  </div>
</template>

<script lang="ts" setup>
import { computed, defineProps } from 'vue';

const props = defineProps<{
  kind: 'track' | 'linked' | 'not-linked';
}>();

const iconName = computed(() => {
  if (props.kind === 'track') return 'location-o';
  if (props.kind === 'linked') return 'shield-o';
  return 'close';
});
</script>

<style scoped>
.card-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0, 122, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
